// removed by extract-text-webpack-plugin
module.exports = {"page":"AcceptEmployer_page__3ql6","form":"AcceptEmployer_form__3QrT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/KingstonConnect/styles/AcceptEmployer.scss
// module id = 710
// module chunks = 0